/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LastSiegeSocialDto
 */
export interface LastSiegeSocialDto {
    /**
     * 
     * @type {string}
     * @memberof LastSiegeSocialDto
     */
    denominationSociale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LastSiegeSocialDto
     */
    fonction?: string | null;
}

/**
 * Check if a given object implements the LastSiegeSocialDto interface.
 */
export function instanceOfLastSiegeSocialDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LastSiegeSocialDtoFromJSON(json: any): LastSiegeSocialDto {
    return LastSiegeSocialDtoFromJSONTyped(json, false);
}

export function LastSiegeSocialDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LastSiegeSocialDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'denominationSociale': !exists(json, 'denominationSociale') ? undefined : json['denominationSociale'],
        'fonction': !exists(json, 'fonction') ? undefined : json['fonction'],
    };
}

export function LastSiegeSocialDtoToJSON(value?: LastSiegeSocialDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'denominationSociale': value.denominationSociale,
        'fonction': value.fonction,
    };
}

